module.exports = __webpack_public_path__ + "img/gryelgrn-mob.556c5ec8.png";